export default __webpack_public_path__ + "static/media/brand-3.12b9a073.png";